import { createContext, useContext, useEffect, useState } from "react";
import es from "./es";
import it from "./it";
import fr from "./fr";
import de from "./de";
import ar from "./ar";
import ja from "./ja";

export const LANGS = [
  { id: "en", label: "English", short: "EN", dir: "ltr" },
  { id: "es", label: "Español", short: "ES", dir: "ltr" },
  { id: "it", label: "Italiano", short: "IT", dir: "ltr" },
  { id: "fr", label: "Français", short: "FR", dir: "ltr" },
  { id: "de", label: "Deutsch", short: "DE", dir: "ltr" },
  { id: "ar", label: "العربية (Arabic)", short: "AR", dir: "rtl" },
  { id: "ja", label: "日本語 (Japanese)", short: "JA", dir: "ltr" },
];

const dicts = { es, it, fr, de, ar, ja };
const KEY = "tlp-lang";

const LangCtx = createContext({ lang: "en", setLang: () => {}, t: (k, fb) => fb });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem(KEY) || "en";
    } catch {
      return "en";
    }
  });

  useEffect(() => {
    const meta = LANGS.find((l) => l.id === lang) || LANGS[0];
    document.documentElement.dir = meta.dir;
    document.documentElement.lang = meta.id;
  }, [lang]);

  const setLang = (l) => {
    try {
      localStorage.setItem(KEY, l);
    } catch {
      // storage unavailable; language still applies for this session
    }
    setLangState(l);
  };

  // English source strings live inline in components as the fallback.
  // If a translation would lose the essence, the key is simply absent and
  // the English original renders, by design.
  const t = (key, fallback) => {
    const d = dicts[lang];
    return (d && d[key]) || fallback;
  };

  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
